module.exports = __webpack_public_path__ + "static/media/facebook.459c258f.png";